import React, { useState, useEffect } from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";

export function DropsAndWins(props) {
    const [button, setButton] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        props.showMenuFn(false);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Drops & Wins', 'casino', props.user);
    }, []);

    const handleButtonClick = () => {
        setButton(!button);
    }

    return (<>
        <MetaTags title="Drops & Wins | SuperSport | SuperCasino" description="Drops & Wins SuperSport Casino!" />

        <Header key="header" {...props} />
        <div className="white-background">

            <div className="drops-and-wins-banner2">
                <section className="drops-and-wins2 banner--inner selected">
                    <div className="banner--content">
                        <div className="banner--bg-container">
                            <div className="banner--repeater" />
                            <div className="banner--repeater2">
                            </div>
                            <div className="banner--background" />
                        </div>
                        <div className="banner--foreground">
                            <div className="rive-container">
                                <RiveComponent
                                    lazyLoad={true}
                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                    src={`${casino.config.casinoCDNImagesUrl}/Banners/DropsAndWins/d&w_web_subpage_v1.riv`}
                                    stateMachines="State Machine 1"
                                    useOffscreenRenderer={true}
                                    playRequest={true}
                                    disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                />
                            </div>
                            <div className="banner-image"></div>
                            <div className="banner--text">
                                <a className="red btn medium fill" href="https://mcasino.supersport.hr/?game_category=drops%20and%20wins">ZAIGRAJ</a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div id="page-wrapper">
                <div className="drops-and-wins-page">

                    <h1 className="text-center">Svaki dan do nagrade!</h1>
                    <p className="paragraph-bold">
                        Osvoji do x100.000 uloga 
                    </p>

                    <p className="paragraph-bold">
                        Pojačaj zabavu, uzbuđenje i nagrade! Uključi se u nevjerojatno napetu Pragmatic Play Drops & Wins igru u kojem imaš priliku igrati vrhunske igre, natjecati se s drugim igračima i osvojiti vrijedne nagrade.
                    </p>

                    <p className="paragraph-bold">
                        Sudjeluj u dnevnim turnirima i Wheel drops nagradama jer zabava te čeka!
                    </p>

                    <div className="tabs-container">
                        <div className="button-container">
                            <button className={`btn-left ${button ? 'btn-disabled' : 'btn-enabled'}`} onClick={handleButtonClick} disabled={button}>Informacije</button>
                            <button className={`btn-right ${button ? 'btn-enabled' : 'btn-disabled'}`} onClick={handleButtonClick} disabled={!button}>Zašto igrati?</button>
                        </div>
                        {button ? <Informacije /> : <Zasto />}
                    </div>

                </div>
            </div>
        </div>
    </>
    )
}

function Informacije() {

    return (
        <>
            <div className="informations">
                <h1 className="text-left">Dnevni turniri</h1>
                <p className="paragraph-regular">
                    Natječi se za svoje mjesto među top igračima i osvoji neku od 500 fenomenalnih dnevnih nagrada! Zaigraj odabrane Pragmatic Play igre uz minimalan ulog od 0,15 € po vrtnji i skupljaj bodove.
                </p>

                <ul>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Svakog dana možeš osvojiti neku od 500 nagrada*.</p></li>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Sudjeluj s minimalnim ulogom od 0,15 € po vrtnji.</p></li>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Ostvari najveći dnevni multiplikator i osvoji jednu od vrijednih novčanih nagrada.</p></li>
                </ul>
                <div className="podium">
                    <span className="first-place">
                        <span className="image"></span>
                        <span className="text">
                            <span className="left">1. mjesto</span>
                            <span className="right">3.000 €</span>
                        </span>
                    </span>
                    <span className="second-place">
                        <span className="image"></span>
                        <span className="text">
                            <span className="left">2. mjesto</span>
                            <span className="right">2.000 €</span>
                        </span>
                    </span>
                    <span className="third-place">
                        <span className="image"></span>
                        <span className="text">
                            <span className="left">3. mjesto</span>
                            <span className="right">1.000 €</span>
                        </span>
                    </span>
                </div>

                <div className="rewards-container-other">
                    <ul>
                        <li className="placement"><span className="grey-text padding-left">4</span><span className="dark-grey-text padding-right padding-right">1000 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">5 - 10</span><span className="dark-grey-text padding-right">500 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">11 - 20</span><span className="dark-grey-text padding-right">200 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">21 - 40</span><span className="dark-grey-text padding-right">100 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">41 - 80</span><span className="dark-grey-text padding-right">50 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">81 - 160</span><span className="dark-grey-text padding-right">20 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">161 - 300</span><span className="dark-grey-text padding-right">10 €</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">301 - 500</span><span className="dark-grey-text padding-right">5 €</span></li>
                        <hr />
                    </ul>
                </div>

                <hr />

                <h1 className="text-left">Tjedne Wheel Drops nagrade</h1>
                <p className="paragraph-regular">
                    Osvoji nagradu u bilo kojoj igri. Postavi ulog, skupi tri nasumična kola i osvoji nagradu.
                </p>

                <ul>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Sudjeluj svaki tjedan tijekom trajanja promocije.</p></li>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Svaki dan se igračima dodjeljuju nagrade do 100.000x iznosa uloga**.</p></li>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Nema minimalnog uloga za sudjelovanje u tjednom Wheel Dropu.</p></li>
                    <li><img src="Content/Images/Bonusi/DropsAndWins/checkmark.png" alt="checkmark" /> <p className="paragraph-bold-list">Možeš osvojiti multiplikatore i besplatne vrtnje.</p></li>
                </ul>

                <div className="rewards-container-other">
                    <ul>
                        <li className="placement"><span className="grey-text">KOLIČINA</span><span className="dark-grey-text margin-left">NAGRADA</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">1</span><span className="dark-grey-text padding-right padding-right">100 000x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">3</span><span className="dark-grey-text padding-right">10 000x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">6</span><span className="dark-grey-text padding-right">5000x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">10</span><span className="dark-grey-text padding-right">1000x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">30</span><span className="dark-grey-text padding-right">500x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">50</span><span className="dark-grey-text padding-right">100x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">300</span><span className="dark-grey-text padding-right">50x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">7500</span><span className="dark-grey-text padding-right">10x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">69000</span><span className="dark-grey-text padding-right">5x</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">5000</span><span className="dark-grey-text padding-right">20 besplatnih vrtnji</span></li>
                        <hr />
                        <li className="placement"><span className="grey-text padding-left">5000</span><span className="dark-grey-text padding-right">10 besplatnih vrtnji</span></li>
                        <hr />
                        {/*<li className="placement"><span className="grey-text padding-left">50</span><span className="dark-grey-text padding-right">1 instant bonus*</span></li>*/}
                        {/*<hr />*/}
                    </ul>
                </div>

                {/*<p className="paragraph-bold-small">*/}
                {/*    *Instant bonus se može osvojiti u igri Wisdom of Athena*/}
                {/*</p>*/}
                <p className="paragraph-bold-small">
                    *Ostvareni bonus potrebno je prihvatiti u sekciji CASINO BONUSI na internet računu igrača u roku od 3 dana od dodjele.
                    <br />
                    Ostvareni bonus koji je isplaćen na igračev internet račun ne može se isplatiti. Iznos ostvarenog bonusa igrač mora odigrati u cijelosti u roku od 5 dana računajući od trenutka prihvaćanja bonusa.
                    <br />
                    Ostvareni bonus nije moguće koristiti za igre na sreću sportsko klađenje, klađenje na loto, virtualne igre ili poker.
                </p>
                <p className="paragraph-bold-small">
                    **Ako je iznos vrtnje veći od 1.00 €, nagrada će biti isplaćena na temelju 1.00 € iznosa vrtnje.
                </p>
            </div>
        </>
    );
}

function Zasto() {
    return (<>
        <div className="reason-container">
            <ul className="reason">
                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/box1.png" alt="Poklon" />
                    <span>
                        Nagrade se mogu dodijeliti bilo kojem igraču koji sudjeluje u bilo kojem trenutku.
                    </span>
                </li>

                <hr />

                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/bag.png" alt="Novac" />
                    <span>
                        Najveći nagradni fond s različitim tipovima nagrada
                    </span>
                </li>

                <hr />

                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/heart.png" alt="Srce" />
                    <span>
                        Uključene su igre koje su omiljene među igračima.
                    </span>
                </li>

                <hr />

                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/bell.png" alt="Obavijest" />
                    <span>
                        Primate trenutne obavijesti u igri kako biste uvijek bili u tijeku.
                    </span>
                </li>

                <hr />

                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/confetti.png" alt="Konfeti" />
                    <span>
                        Tijekom promotivnog razdoblja, uvedeni su novi promotivni mehanizmi.
                    </span>
                </li>

                <hr />

                <li className="reason-list">
                    <img src="Content/Images/Bonusi/DropsAndWins/snap2.png" alt="Ruka" />
                    <span>
                        Korisničko sučelje omogućuje igračima praćenje njihovog mjesta na ljestvici turnira u realnom vremenu.
                    </span>
                </li>
            </ul>
        </div>
    </>
    );
}